import { render, staticRenderFns } from "./SentDocumentList.vue?vue&type=template&id=289df85a"
import script from "./SentDocumentList.vue?vue&type=script&lang=js"
export * from "./SentDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports